import SignUp from "../containers/auth/SignUp";
import {makeStyles, createStyles, Typography, Button, Theme} from "@material-ui/core";
import {Box} from "@material-ui/core";
import AssignmentIndOutlinedIcon from "@material-ui/icons/AssignmentIndOutlined";
const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    centerContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      minWidth: "1600px",
      height: "100vh",
      backgroundColor: theme.palette.custom.light,
    },

    loginContainer: {
      position: "relative",
      overflow: "hidden",
      display: "flex",
      width: "68%",
      height: "66vh",
      background: "linear-gradient(135deg,  #267dff, #48c6ef)",
      borderRadius: "20px",
      boxShadow: `16px 16px 30px ${theme.palette.custom.dark}`,
    },

    loginSide: {
      flexBasis: "50%",
      height: "100%",
      paddingLeft: "100px",
      background: "transparent",
    },
    loginForm: {
      overflow: "hidden",
      flexBasis: "50%",
      height: "100%",
      borderRadius: "30px 0 0 30px",
      textAlign: "center",
    },
    loginImage1: {
      position: "absolute",
      top: "60%",
      left: "50%",
      transform: "translate(-50%)",
      width: "160px",
      height: "160px",
      border: "24px solid #fff",
      borderColor: theme.palette.background.paper,
      borderRadius: "50%",
    },
    loginImage2: {
      position: "absolute",
      top: "20%",
      right: "0",
      transform: "translate(50%)",
      width: "160px",
      height: "160px",
      // backgroundColor: "red",
      border: "24px solid #267dff",
      borderRadius: "50%",
    },
    readMeBtn: {
      margin: "24px 0 0 24px",
      color: "white",
      borderColor: "white",
    },
  })
);

const LogIn = () => {
  const classes = useStyle();
  return (
    <>
      <article className={classes.centerContainer}>
        <section className={classes.loginContainer}>
          <Box className={classes.loginSide}>
            <Typography
              variant="h4"
              component="h4"
              style={{paddingTop: "150px", color: "white", fontWeight: 600}}
            >
              Welcome to KISA Inspect
            </Typography>
            <Typography variant="h6" style={{paddingTop: "20px", color: "white"}}>
              <AssignmentIndOutlinedIcon style={{verticalAlign: "middle", paddingRight: "10px"}} />
              KISA safety diagnosis
            </Typography>
            <Button variant="outlined" className={classes.readMeBtn}>
              Read More
            </Button>
          </Box>
          <Box className={classes.loginForm}>
            <SignUp />
          </Box>
          <Box className={classes.loginImage1}>{/* <img src={loinImage} alt="" /> */}</Box>
          <Box className={classes.loginImage2}>{/* <img src={loinImage} alt="" /> */}</Box>
        </section>
      </article>
    </>
  );
};

export default LogIn;
